import type { Timestamp } from 'firebase/firestore';

/**
 * Sections that have standard catalog entries.
 * `production` is always custom per project — no catalog entries.
 */
export const CATALOG_SECTIONS = [
  'rd',
  'npi',
  'prototypes',
  'nre',
  'certification',
] as const;
export type CatalogSection = (typeof CATALOG_SECTIONS)[number];

export const BILLING_MODES = ['hourly', 'fixed'] as const;
export type BillingMode = (typeof BILLING_MODES)[number];

export interface CatalogDesignation {
  id: string;
  section: CatalogSection;
  name: string;
  variants: string[];
  billingMode: BillingMode;
  isArchived: boolean;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}
